module.exports = __webpack_public_path__ + "img/25-durango-nav.7fc87154.png";